// API endpoints are driven by build-time env vars (Create React App: REACT_APP_*).
// Set them in 0_web_labelflow/.env (see .env.example). Falls back to localhost for
// local development if the vars are not provided at build time.
//
// These may be ABSOLUTE ("http://host:7001/api_labelflow") for direct access, or
// RELATIVE ("/api_labelflow") when the FE is served over HTTPS and both APIs are
// proxied through the same origin (see 3_infra/nginx/labelflow.conf). Relative
// bases avoid mixed-content blocking because the browser only ever sees HTTPS
// same-origin requests. axios and the WebSocket builder both handle either form.

export const api_labelflow =
  process.env.REACT_APP_API_LABELFLOW || "http://127.0.0.1:7001/api_labelflow";

export const api_labelflow_training =
  process.env.REACT_APP_API_LABELFLOW_TRAINING ||
  "http://127.0.0.1:7002/api_labelflow_training";

// alias used by the prediction page
export const apiTrainingAPIPath = api_labelflow_training;
